import { UI_SIZE } from '@constants/ui';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import type { SxProps, Theme } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useLogoutMutation } from '@store/api/authEndpoints';
import { useAppSelector } from '@store/hooks';
import MenuContent from '../Menu/MenuContent';

interface CompactSideBarProps {
  open: boolean;
  toggleDrawer: () => void;
}

/** The sidebar for viewports below `lg`, opened from the app bar. */
const CompactSideBar = ({ open, toggleDrawer }: CompactSideBarProps) => {
  const [logout] = useLogoutMutation();
  const user = useAppSelector((state) => state.auth.user);

  return (
    <Drawer anchor='right' open={open} onClose={toggleDrawer} sx={drawerStyles}>
      <Stack sx={{ width: UI_SIZE.DRAWER_WIDTH, height: '100%' }}>
        <Stack direction='row' sx={{ padding: 2, paddingBottom: 0, gap: 1 }}>
          <Stack direction='row' sx={{ gap: 1, alignItems: 'center', flexGrow: 1, padding: 1 }}>
            <Avatar sizes='small' alt={user?.name} sx={{ width: 24, height: 24 }} />
            <Typography component='p' variant='h6'>{user?.name}</Typography>
          </Stack>
        </Stack>
        <Divider />
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent toggleDrawer={toggleDrawer} />
          <Divider />
        </Stack>
        <Stack sx={{ padding: 2 }}>
          <Button onClick={() => logout()} variant='outlined' fullWidth startIcon={<LogoutRoundedIcon />}>
            Sign out
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
};

const drawerStyles: SxProps<Theme> = {
  width: UI_SIZE.DRAWER_WIDTH,
  [`& .${drawerClasses.paper}`]: {
    backgroundImage: 'none',
    backgroundColor: 'background.paper',
  },
};

export default CompactSideBar;
